import { energyStarPageKeys, guidedSectionMapping } from '../../const';
import '../../DataSharing.scss';
import { CongratsTemplate } from '../../CommonTemplates';
import { updateSectionStatusThunk } from '../../../../../redux/inputSheet/inputSheetSlice';
import { useSelector, useDispatch } from 'react-redux';

export function SuccessPopup({ onClose, buildingName }) {
	const dispatch = useDispatch();
	const propertyId = useSelector((state) => state.selectedBuilding.prop_id);

	const handleClose = () => {
		dispatch(
			updateSectionStatusThunk({
				propertyId,
				data: {
					[guidedSectionMapping['Energy Star Access'].key]: {
						isComplete: true,
						isStarted: true,
						section_id: guidedSectionMapping['Energy Star Access'].section_id,
					},
				},
			})
		);
		onClose();
	};
	return (
		<CongratsTemplate
			onClick={handleClose}
			title="Access received!"
			message={`Access to ENERGY STAR data for ${buildingName} is now enabled.`}
			additionalTitleStyles={{ width: '100%' }}
		/>
	);
}

export function AlreadyConnected({ setCurrentPage }) {
	return (
		<CongratsTemplate
			onClick={() => {
				setCurrentPage(energyStarPageKeys.GET_PROPERTY_NUMBER);
			}}
			title="Account connected!"
			message="Joulea is already connected with your ENERGY STAR account."
			additionalTitleStyles={{ width: '100%' }}
		/>
	);
}

export function AlreadyShared({ onClose, buildingName }) {
	const dispatch = useDispatch();
	const propertyId = useSelector((state) => state.selectedBuilding.prop_id);

	const handleClose = () => {
		dispatch(
			updateSectionStatusThunk({
				propertyId,
				data: {
					[guidedSectionMapping['Energy Star Access'].key]: {
						isComplete: true,
						isStarted: true,
						section_id: guidedSectionMapping['Energy Star Access'].section_id,
					},
				},
			})
		);
		onClose();
	};

	return (
		<CongratsTemplate
			onClick={handleClose}
			title="Property shared!"
			message={`Joulea already has access to ${buildingName}’s ENERGY STAR data.`}
			additionalTitleStyles={{ width: '100%' }}
		/>
	);
}
